import React from 'react';
import classNames from 'classnames';
import Field from '../../../../../../../../../../../../BaseComponents/Forms/EDField';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EkonomiskAnalysEditColumnUnitQuery from '../Queries/EkonomiskAnalysEditColumnUnitQuery/EkonomiskAnalysEditColumnUnitQuery';
import EDStandardSelect from '../../../../../../../../../../../../BaseComponents/Selects/StandardSelect/EDStandardSelect';
import EDAvenyProgress from '../../../../../../../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';

const styles = (theme: Theme) => ({
  select: {
    display: 'block',
  },
  hidden: {
    visibility: 'hidden',
  },
  selectInput: {
    width: '100%',
  },
});

interface IProps {
  hidden: boolean;
  classes?: any;
}

export interface IColumnUnitType {
  id: number;
  displayLabel: string;
}

class EkonomiskAnalysEditColumnUnitField extends React.Component<IProps> {
  render() {
    return (
      <EkonomiskAnalysEditColumnUnitQuery>
        {({ columnUnits, error, loading }) => {
          return (
            <>
              {loading && <EDAvenyProgress />}
              {!loading && !error && columnUnits && (
                <Field name="columnUnit">
                  {({ value, onChange }) => (
                    <EDStandardSelect
                      label="Enhet"
                      value={value || ''}
                      onChange={onChange}
                      items={columnUnits.map(unit => ({
                        header: unit.ENHET || '',
                        value: unit.id,
                      }))}
                      formControlRoot={classNames(this.props.classes.select, {
                        [this.props.classes.hidden]: this.props.hidden,
                      })}
                      inputClass={this.props.classes.selectInput}
                      fullWidth
                      tooltip="Enhet"
                    />
                  )}
                </Field>
              )}
            </>
          );
        }}
      </EkonomiskAnalysEditColumnUnitQuery>
    );
  }
}

export default withStyles(EkonomiskAnalysEditColumnUnitField, styles);
